import { get, post } from './helpers'

const getItemList = get('/api/shop/getItemList')

const getSkyItemList = get('/api/skyShop/getItemList')

const commitOrder = post('/api/shop/commitOrder')

export {
  getItemList,
  commitOrder,
  getSkyItemList
}
